<template>
  <div
    position-right
    color="primary"
    class="manning-vessel-crew-info-sidebar"
    spacer
    v-if="show"
    not-close
  >
    <div class="sidebar-header" slot="header">
      <div class="sidebar-title">
        {{ vesselInfoText }}
      </div>
      <div class="sidebar-subtitle">
        乗船予定：{{ embarkDate }}～{{ disembarkDate }}
      </div>
      <button class="sidebar-close-btn" @click="close">×</button>
    </div>

    <vs-collapse accordion>
      <vs-collapse-item
        v-for="(section, idx) in [...dynamicTodoSections, ...filteredSections]"
        :key="idx"
        :index="idx"
      >
        <div @click="openAccordion(section)" slot="header">
          {{ section.title }}
        </div>
        <div class="sidebar-section-content">
          <component
            v-if="section.component"
            :is="section.component"
            v-bind="section.props"
            @refresh="fetchSectionData(section.title)"
            @editing="onEditing"
            @saved="onSaved"
            @save-failed="onSaveFailed"
            @cancel="onChildCancel"
          />
          <div v-else>
            {{ section.content }}
          </div>
        </div>
      </vs-collapse-item>
    </vs-collapse>
  </div>
</template>

<script>
import ManningVesselCrewTodo from "./manning-vessel-crew-todo/ManningVesselCrewTodo.vue";
import CrewPositionList from "./manning-vessel-crew-todo/CrewPositionList.vue";
import CrewRoleList from "./manning-vessel-crew-todo/CrewRoleList.vue";
import VisitRecordList from "./manning-vessel-crew-todo/VisitRecordList.vue";
import CrewBasicInfor from "./manning-vessel-crew-todo/CrewBasicInfor.vue";
import CrewQualification from "./manning-vessel-crew-todo/CrewQualification.vue";
import CrewChangeHistory from "./manning-vessel-crew-todo/CrewChangeHistory.vue";
import CrewRemark from "./manning-vessel-crew-todo/CrewRemark.vue";
import EnterpriseManningVesselCrewService from "../../services/master/EnterpriseManningVesselCrewService";
import EnterpriseManningVesselCrewTodoService from "../../services/master/EnterpriseManningVesselCrewTodoService";
import EnterpriseManningVesselCrewVisitRecordService from "../../services/master/EnterpriseManningVesselCrewVisitRecordService";
import EnterpriseManningVesselCrewReposibilitiesService from "../../services/master/EnterpriseManningVesselCrewResposibilitiesService";
import { HandleHttpErrorService } from "../../../utils/errors";

import C from "../../Constants";

export default {
  name: "ManningVesselCrewInfo",
  components: {
    ManningVesselCrewTodo,
    CrewPositionList,
    CrewRoleList,
    VisitRecordList,
    CrewBasicInfor,
    CrewQualification,
    CrewChangeHistory,
    CrewRemark,
  },
  data() {
    return {
      show: false,
      schedulingStatus: null,
      isEditing: false,
      pendingAccordion: null,
      vesselInfoText: "",
      embarkDate: "",
      disembarkDate: "",
      crewVesselData: null,
      crewVesselTodoData: null,
      crewVesselTodoDataValue: {},
      crewVesselVisitRecordData: null,
      crewResposibilities: [],
      crewResposibilitiesList: [],
      sections: [
        {
          title: "役職",
          component: "CrewPositionList",
        },
        {
          title: "役割",
          component: "CrewRoleList",
        },
        {
          title: "訪船記録",
          component: "VisitRecordList",
        },
        { title: "基本情報", component: "CrewBasicInfor" },
        { title: "資格", component: "CrewQualification" },
        { title: "変更履歴", component: "CrewChangeHistory" },
        { title: "備考", component: "CrewRemark" },
      ],
    };
  },
  methods: {
    onEditing() {
      this.isEditing = true;
    },
    onSaved() {
      this.isEditing = false;
      this.$vs.notify({
        text: "更新に成功しました。",
        color: "success",
        iconPack: "feather",
        icon: "icon-check",
      });
    },
    onSaveFailed() {
      this.$vs.notify({
        text: "更新に失敗しました。再読み込み後に再度お試しください。",
        color: "danger",
        iconPack: "feather",
        icon: "icon-alert-circle",
      });
    },
    onChildCancel() {
      if (this.isEditing) {
        this.$vs.dialog({
          type: "confirm",
          color: "warning",
          title: "キャンセル",
          text: "未保存の変更があります。閉じてもよろしいですか？",
          cancelText: "キャンセル",
          acceptText: "OK",
          accept: () => {
            this.show = false;
            this.isEditing = false;
          },
          cancel: () => {},
        });
      } else {
        this.show = false;
      }
    },
    openAccordion() {
      this.isEditing = false;
      for (const section of this.dynamicTodoSections) {
        this.fetchSectionData(section.title);
      }
      this.fetchSectionData("訪船記録");
      this.fetchSectionData("役割");
      this.fetchSectionData("備考");
    },
    async open(eventRecord, manningVessels, crews) {
      try {
        this.schedulingStatus = eventRecord.data.scheduling_status;
        const crewId = eventRecord.data.enterprise_manning_vessel_crew_id;

        this.crewVesselData = await EnterpriseManningVesselCrewService.fetchById(
          crewId
        );

        let crew = null;
        let crewName = "";
        if (
          crews &&
          Array.isArray(crews.crews) &&
          this.crewVesselData &&
          this.crewVesselData.enterprise_crew_id
        ) {
          crew = crews.crews.find(
            c => String(c.id) === String(this.crewVesselData.enterprise_crew_id)
          );
          if (crew) crewName = crew.name;
        }

        let vesselName = "";
        let positionName = "";
        if (manningVessels && Array.isArray(manningVessels.manning_vessels)) {
          const vessel = manningVessels.manning_vessels.find(
            v =>
              String(v.id) ===
              String(this.crewVesselData.enterprise_manning_vessel_id)
          );
          if (vessel) vesselName = vessel.name;

          if (
            vessel &&
            Array.isArray(
              this.crewVesselData.enterprise_manning_vessel_crew_roles
            ) &&
            this.crewVesselData.enterprise_manning_vessel_crew_roles.length > 0
          ) {
            const crewRole = this.crewVesselData
              .enterprise_manning_vessel_crew_roles[0];
            const vesselRole = vessel.manning_vessel_roles.find(
              vr =>
                String(vr.enterprise_crew_role_id) ===
                String(crewRole.enterprise_crew_role_id)
            );
            if (
              vesselRole &&
              Array.isArray(vesselRole.manning_vessel_role_positions)
            ) {
              const pos = vesselRole.manning_vessel_role_positions.find(
                p =>
                  String(p.id) ===
                  String(crewRole.enterprise_manning_vessel_role_position_id)
              );
              if (pos) positionName = pos.name;
            }
          }
        }

        const formatDate = dateStr => {
          if (!dateStr) return "";
          const d = new Date(dateStr);
          return `${d.getFullYear()}/${(d.getMonth() + 1)
            .toString()
            .padStart(2, "0")}/${d
            .getDate()
            .toString()
            .padStart(2, "0")}`;
        };
        this.vesselInfoText = `${vesselName} ${positionName} ${crewName}`.trim();
        this.embarkDate = formatDate(this.crewVesselData.start_at);
        this.disembarkDate = formatDate(this.crewVesselData.end_at);

        this.sections.find(s => s.title === "基本情報").props = { crew };
        this.sections.find(s => s.title === "資格").props = { crew };

        if (this.schedulingStatus === "SCHEDULED") {
          this.crewVesselTodoData = await EnterpriseManningVesselCrewTodoService.fetch();

          for (const todo of this.crewVesselTodoData.todos) {
            this.crewVesselTodoDataValue[
              todo.id
            ] = await EnterpriseManningVesselCrewTodoService.fetchValue(
              this.crewVesselData.id,
              todo.id
            );
          }

          let positions = [];
          if (
            manningVessels &&
            Array.isArray(manningVessels.manning_vessels) &&
            this.crewVesselData &&
            this.crewVesselData.enterprise_manning_vessel_id
          ) {
            const vessel = manningVessels.manning_vessels.find(
              v =>
                String(v.id) ===
                String(this.crewVesselData.enterprise_manning_vessel_id)
            );
            if (
              vessel &&
              Array.isArray(
                this.crewVesselData.enterprise_manning_vessel_crew_roles
              )
            ) {
              positions = this.crewVesselData.enterprise_manning_vessel_crew_roles.map(
                crewRole => {
                  let positionName = "";
                  const vesselRole = vessel.manning_vessel_roles.find(
                    vr =>
                      String(vr.enterprise_crew_role_id) ===
                      String(crewRole.enterprise_crew_role_id)
                  );
                  if (
                    vesselRole &&
                    Array.isArray(vesselRole.manning_vessel_role_positions)
                  ) {
                    const pos = vesselRole.manning_vessel_role_positions.find(
                      p =>
                        String(p.id) ===
                        String(
                          crewRole.enterprise_manning_vessel_role_position_id
                        )
                    );
                    if (pos) positionName = pos.name;
                  }
                  return {
                    start_at: crewRole.start_at,
                    position_name: positionName,
                  };
                }
              );
            }
          }

          this.crewVesselVisitRecordData = await EnterpriseManningVesselCrewVisitRecordService.fetch(
            crewId
          );
          this.crewResposibilities = await EnterpriseManningVesselCrewReposibilitiesService.fetch();
          this.crewResposibilitiesList = await EnterpriseManningVesselCrewReposibilitiesService.fetchList(
            crewId
          );

          this.sections.find(s => s.title === "役職").props = { positions };
          this.sections.find(s => s.title === "変更履歴").props = {
            histories:
              this.crewVesselData
                .enterprise_manning_vessel_crew_update_histories || [],
          };
          this.sections.find(s => s.title === "備考").props = {
            remarks: [this.crewVesselData.remarks] || [],
            crewId: this.crewVesselData.id,
            version: this.crewVesselData.version || "1",
          };
          this.sections.find(s => s.title === "訪船記録").props = {
            records: this.crewVesselVisitRecordData.visits || [],
            crewId,
          };
          this.sections.find(s => s.title === "役割").props = {
            crewResposibilitiesList:
              this.crewResposibilitiesList.responsibilities || [],
            crewResposibilities:
              this.crewResposibilities.responsibilities || [],
            crewId,
          };
        }

        this.show = true;
      } catch (error) {
        const errorMessage = HandleHttpErrorService.handleErrorNotificationMessage(
          error
        );
        this.$vs.notify({
          title: "Error",
          text: errorMessage,
          color: "danger",
        });
        this.show = false;
      }
    },

    async fetchSectionData(title) {
      const crewId = this.crewVesselData.id;

      const todo = this.crewVesselTodoData.todos.find(t => t.name === title);
      if (todo) {
        const value = await EnterpriseManningVesselCrewTodoService.fetchValue(
          crewId,
          todo.id
        );
        this.crewVesselTodoDataValue = {
          ...this.crewVesselTodoDataValue,
          [todo.id]: { ...value },
        };
      }

      if (title === "訪船記録") {
        const visitData = await EnterpriseManningVesselCrewVisitRecordService.fetch(
          crewId
        );
        this.sections.find(s => s.title === "訪船記録").props = {
          records: visitData.visits || [],
          crewId: this.crewVesselData.id,
        };
      }

      if (title === "役割") {
        const crewResposibilities = await EnterpriseManningVesselCrewReposibilitiesService.fetch();
        const crewResposibilitiesList = await EnterpriseManningVesselCrewReposibilitiesService.fetchList(
          crewId
        );
        this.sections.find(s => s.title === "役割").props = {
          crewResposibilitiesList:
            crewResposibilitiesList.responsibilities || [],
          crewResposibilities: crewResposibilities.responsibilities || [],
          crewId: this.crewVesselData.id,
        };
      }

      if (title === "備考") {
        const refreshedCrew = await EnterpriseManningVesselCrewService.fetchById(
          crewId
        );
        this.sections.find(s => s.title === "備考").props = {
          remarks: [refreshedCrew.remarks],
          crewId: this.crewVesselData.id,
          version: refreshedCrew.version || 1,
        };
      }
    },

    close() {
      if (this.isEditing) {
        this.$vs.dialog({
          type: "confirm",
          color: "warning",
          title: "閉じる",
          text: "編集中 – 閉じてもよろしいですか？",
          cancelText: "キャンセル",
          acceptText: "OK",
          accept: () => {
            this.isEditing = false;
            this.show = false;
          },
          cancel: () => {},
        });
      } else {
        this.show = false;
      }
    },
  },

  computed: {
    dynamicTodoSections() {
      if (
        !this.crewVesselTodoData ||
        !Array.isArray(this.crewVesselTodoData.todos) ||
        this.schedulingStatus === C.SCHEDULING_STATUS.PLANNING
      )
        return [];
      return this.crewVesselTodoData.todos
        .slice()
        .sort((a, b) => a.sort_order - b.sort_order)
        .map(todo => ({
          title: todo.name,
          type: todo.type,
          master: todo,
          component: "ManningVesselCrewTodo",
          props: {
            master: todo,
            value: this.crewVesselTodoDataValue
              ? this.crewVesselTodoDataValue[todo.id] || {}
              : {},
            crewId: this.crewVesselData.id,
            version: this.crewVesselData.version || "0",
          },
        }));
    },
    filteredSections() {
      const status = this.schedulingStatus;
      return this.sections.filter(section => {
        switch (section.title) {
          case "役職":
          case "訪船記録":
          case "役割":
          case "変更履歴":
          case "備考":
            return status === C.SCHEDULING_STATUS.SCHEDULED;
          case "基本情報":
          case "資格":
            return (
              status === C.SCHEDULING_STATUS.SCHEDULED ||
              status === C.SCHEDULING_STATUS.PLANNING
            );
          default:
            return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.manning-vessel-crew-info-sidebar {
  position: absolute;
  height: 100%;
  top: 0;
  right: 0;
  background-color: white;
  width: 535px;
  overflow: auto;
}

.manning-vessel-crew-info-sidebar {
  :deep(.vs-sidebar--header) {
    padding: unset;
  }

  :deep(.vs-sidebar--items) {
    padding: 0;
  }

  :deep(.vs-collapse) {
    margin: 0;
    padding: 0;
  }

  :deep(.sidebar-header) {
    padding: 12px 10px 12px 16px;
  }

  :deep(.sidebar-title) {
    font-size: 1.2rem;
    margin-bottom: 4px;
  }

  :deep(.sidebar-subtitle) {
    font-size: 1.2rem;
    color: #666;
    margin-bottom: 8px;
  }

  :deep(.vs-collapse.default .open-item .con-content--item) {
    padding: unset;
  }

  :deep(.sidebar-section-content) {
    background: #fff;
    color: rgb(16, 17, 17);
  }

  :deep(.vs-collapse-item--header) {
    text-align: left;
    padding-left: 48px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.04);
  }

  :deep(.vs-collapse-item--icon-header) {
    right: unset;
    left: 28px;
  }

  :deep(.vs-collapse-item--icon-header .vs-icon) {
    font-size: 28px !important;
    width: 28px;
    height: 28px;
    color: gray;
  }

  :deep(.sidebar-close-btn) {
    position: absolute;
    top: 12px;
    right: 16px;
    background: none;
    border: none;
    font-size: 1.6rem;
    color: #888;
    cursor: pointer;
  }
}
</style>
